import { useState } from "react";

import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import { useApi } from "../hooks/useApi";

const InviteBarberDialog = ({
  showInviteBarberDialog,
  setShowInviteBarberDialog,
  setShowInviteAlert,
  onSave,
}) => {
  const api = useApi();

  const [barber, setBarber] = useState({
    first_name: "",
    last_name: "",
    email: "",
    role: "barber",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setShowInviteBarberDialog(false);
    }
  };

  const inviteBarber = async () => {
    setSubmitted(true);
    setIsSubmitting(true);
    setShowAlert({ show: false, message: "", type: "" });

    try {
      await api("/barbers/invite.php", {
        method: "POST",
        body: JSON.stringify(barber),
      });

      setShowInviteAlert({
        show: true,
        message: "Successfully invited barber.",
        type: "success",
      });
      setShowInviteBarberDialog(false);
      onSave();
    } catch (err) {
      setShowAlert({ show: true, message: err.message, type: "error" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog
      open={showInviteBarberDialog}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        Invite Barber
        <IconButton
          //disabled={isSubmitting}
          aria-label="close"
          onClick={() => setShowInviteBarberDialog(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {showAlert.show === true && (
          <Alert sx={{ mb: 2 }} severity={showAlert.type}>
            {showAlert.message}
          </Alert>
        )}
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid size={6}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              First Name
            </Typography>
            <TextField
              variant="outlined"
              name="firstName"
              label=""
              fullWidth
              placeholder="First Name"
              value={barber.first_name}
              disabled={isSubmitting}
              error={submitted && !barber.first_name}
              helperText={
                submitted && !barber.first_name ? "First name is required" : ""
              }
              onChange={(e) => {
                setBarber((prev) => ({ ...prev, first_name: e.target.value }));
              }}
            />
          </Grid>
          <Grid size={6}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              Last Name
            </Typography>
            <TextField
              variant="outlined"
              name="lastName"
              label=""
              fullWidth
              placeholder="Last Name"
              value={barber.last_name}
              disabled={isSubmitting}
              error={submitted && !barber.last_name}
              helperText={
                submitted && !barber.last_name ? "Last name is required" : ""
              }
              onChange={(e) => {
                setBarber((prev) => ({ ...prev, last_name: e.target.value }));
              }}
            />
          </Grid>
          <Grid size={12}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              Email
            </Typography>
            <TextField
              variant="outlined"
              name="email"
              label=""
              fullWidth
              placeholder="Email"
              value={barber.email}
              disabled={isSubmitting}
              error={submitted && !barber.email}
              helperText={submitted && !barber.email ? "Email is required" : ""}
              onChange={(e) => {
                setBarber((prev) => ({ ...prev, email: e.target.value }));
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setShowInviteBarberDialog(false)}
          disabled={isSubmitting}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => inviteBarber()}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <CircularProgress
              enableTrackSlot
              size="25px"
              sx={{ color: "text.primary" }}
            />
          ) : (
            "Invite Barber"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InviteBarberDialog;
